import { Grid, Stack, SxProps } from "@mui/material";
import { useContext } from "react";

import CrossExitBtn from "../../components/CrossExitBtn";
import Context from "../../context";
import CardWrapper from "../CardWrapper";
import Powered from "../Powered";
import CustomLogo from "./CustomLogo";
import InfoHeader from "./InfoHeader";
import InfoList from "./InfoList";
import MobileBtn from "./MobileBtn";

// ----------------------------------------------------------------------

type Props = {
	sx?: SxProps;
	isSelected?: boolean;
};

export const InfoPanelCard = ({ sx, isSelected }: Props) => {
	const { state, values } = useContext(Context);

	const isMobile = state.isMobile;

	return (
		<CardWrapper sx={sx} isSelected={isSelected}>
			<Stack minWidth={{ xs: 250, sm: 330 }} width={isMobile ? 340 : "auto"}>
				{values.file && <CustomLogo />}
				{values.showExit && <CrossExitBtn />}
				<Grid container spacing={4} sx={{ mt: !values.file && values.showExit ? 2 : -2 }}>
					<InfoHeader />
					<Grid item xs={isMobile ? 12 : 6}>
						<InfoList />
					</Grid>
				</Grid>
				{isMobile && <MobileBtn />}
				<Powered />
			</Stack>
		</CardWrapper>
	);
};

export default InfoPanelCard;
